import styles from "./components-gantt-mapping.module.css";
import classNames from "classnames";
import { useRef } from "react";
import { useHover } from "usehooks-ts";

export const dateTabKey = "date-tab";
export type DateTab = "start-end" | "timeline";

function RadioGroup({
  name,
  value,
  onChange,
  options,
  theme = "light",
}: {
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{ title: string; value: string; disabled?: boolean; tooltip?: string }>;
  theme?: "light" | "dark";
}) {
  return (
    <div className={classNames(styles.dateRadios, styles[theme])}>
      {options.map((option) => (
        <LabelWithTollip
          key={option.value}
          name={name}
          title={option.title}
          value={option.value}
          disabled={option.disabled}
          checked={value === option.value}
          onChange={onChange}
          tooltip={option.tooltip}
          theme={theme}
        />
      ))}
    </div>
  );
}

const LabelWithTollip = ({
  name,
  title,
  value,
  disabled,
  checked,
  onChange,
  tooltip,
  theme = "light",
}: {
  name: string;
  title: string;
  value: string;
  disabled?: boolean;
  checked?: boolean;
  tooltip?: string;
  onChange: (value: string) => void;
  theme?: "light" | "dark";
}) => {
  const labelRef = useRef<HTMLLabelElement | null>(null);
  const labelHover = useHover(labelRef);
  return (
    <>
      <label
        className={classNames(styles["custom-radio"], styles[theme], disabled && styles.disabled)}
        data-testid={`${name}-option-${value}`}
        ref={labelRef}
      >
        <input
          type="radio"
          name={name}
          value={value}
          onChange={() => onChange(value)}
          checked={checked}
          disabled={disabled}
        />
        {title}
      </label>
      {disabled && labelHover && (
        <div
          className={styles.tooltip}
          style={{ left: labelRef.current?.offsetLeft, top: (labelRef.current?.offsetTop ?? 0) + 30 }}
        >
          {tooltip}
          <div className={styles.arrow} />
        </div>
      )}
    </>
  );
};

export function TypeOfDateMapping({
  name,
  value,
  onChange,
  disableTimeline,
  disableDates,
  theme = "light",
}: {
  name: string;
  value: string;
  onChange: (value: string) => void;
  disableTimeline?: boolean;
  disableDates?: boolean;
  theme?: "light" | "dark";
}) {
  return (
    <RadioGroup
      name={name}
      value={value}
      onChange={onChange}
      options={[
        {
          title: "Timeline",
          value: "timeline",
          disabled: disableTimeline,
          tooltip: "This board has no timeline column",
        },
        {
          title: "Date",
          value: "start-end",
          disabled: disableDates,
          tooltip: "This board doesn't have enough date column",
        },
      ]}
      theme={theme}
    />
  );
}
